import { useAppSelector } from 'app/hooks';
import { Equipment } from 'domains/eqptDomain';
import { useParams } from 'react-router-dom';

export const useParentEqpt = () => {
  const { eqptid } = useParams<{ eqptid?: string }>();
  const eqptList = useAppSelector((state) => state.eqpt.data?.content);
  const eqpt = eqptList?.find((e) => e.id === Number(eqptid));
  return eqpt || ({ id: Number(eqptid) } as Equipment);
};
